export const tagBoxTypes = {
    default: 'default',
    linear: 'linear',
};